<ng-template #productlineFilter let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Product Line Filtering</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<app-chiplist-filter [prods]="prods" (selectionChange)="updateProductLinesFromModal($event)"></app-chiplist-filter>
	</div>
</ng-template>

<ng-container *ngIf="filters">
	<div class="filter-wrap" [class.filter-wrap--toolbar]="inlineToolbar">

		<ng-container *ngFor="let filter of filters">
			<div class="filter-group">

				<div class="filter-group-label" *ngIf="filter.input_type === 'checkbox' || filter.input_type === 'modal'">
					{{ filter.name }}
				</div>

				<ng-container *ngIf="(filter.name === 'Product Line' || filter.name === 'Manufacturer') && filter.input_type === 'checkbox'">
					<mat-form-field appearance="outline" class="w-100 filter-line-search" [matTooltip]="'Type * to toggle all visible lines'">
						<mat-label>Search {{ filter.name }}…</mat-label>
						<input matInput [formControl]="linesearchref" autocomplete="off" />
						<button matSuffix type="button" mat-icon-button class="filter-line-clear" (click)="resetProdlines()" aria-label="Clear search and product line selections">
							<mat-icon>close</mat-icon>
						</button>
					</mat-form-field>
				</ng-container>

				<ng-container *ngIf="filter.name === 'Product Line' && filter.input_type == 'modal'">
					<button type="button" class="btn-productline" mat-mini-fab [matBadge]="prods.length" (click)="openProductLines()">
						<mat-icon>segment</mat-icon>
					</button>
				</ng-container>

				<ng-container *ngIf="filter.input_type == 'select'">
					<mat-form-field appearance="outline" class="w-100 custom-mat-select">
						<mat-label>{{ filter.name }}</mat-label>
						<mat-select [(value)]="filter.default_value" (selectionChange)="updateSearchSelect($event, filter.filter_id)" panelClass="custom-mat-panel">
							<mat-option *ngIf="issalesman" value="reset">All</mat-option>
							<mat-option *ngFor="let opt of filter.options" [value]="opt.value">{{ opt.label }}</mat-option>
						</mat-select>
					</mat-form-field>
				</ng-container>

				<ng-container *ngIf="filter.input_type == 'multis'">
					<mat-form-field appearance="outline" class="w-100">
						<mat-label>{{ filter.name }}</mat-label>
						<mat-select [(value)]="filter.default_value" (selectionChange)="updateSearchSelect($event, filter.filter_id)" multiple appSelectAll>
							<mat-option *ngFor="let opt of filter.options" [value]="opt.value">{{ opt.label }}</mat-option>
						</mat-select>
					</mat-form-field>
				</ng-container>

				<ng-container *ngIf="filter.input_type == 'checkbox'">
					<div class="filter-checkboxes" [class.filter-checkboxes--toolbar-scroll]="inlineToolbar">
						<mat-checkbox class="filter-checkbox" *ngFor="let opt of filter.options"
							[value]="opt.value"
							(change)="updateChecks($event, filter.filter_id)"
							[checked]="opt.checked"
							[matTooltip]="opt.label"
							matTooltipHideDelay="1"
							matTooltipPosition="right">
							{{ opt.label }}
						</mat-checkbox>
					</div>
				</ng-container>

			</div>
		</ng-container>

		<div class="filter-actions">
			<button type="button" mat-raised-button color="primary"
				(keyup.enter)="$event.preventDefault();"
				(keydown.enter)="$event.preventDefault();"
				(click)="$event.preventDefault(); requestSearch();">
				<mat-icon>search</mat-icon> Search
			</button>
			<button type="button" mat-stroked-button
				(keyup.enter)="$event.preventDefault();"
				(keydown.enter)="$event.preventDefault();"
				(click)="$event.preventDefault(); resetFilters();">
				<mat-icon>restore</mat-icon> Reset
			</button>
		</div>

	</div>
</ng-container>
